const NAV_THEME_STORAGE_KEY = 'app_nav_theme';

export type NavTheme = 'light' | 'realDark';

export const saveNavTheme = (theme: NavTheme) => {
  if (typeof window === 'undefined') return;
  window.localStorage.setItem(NAV_THEME_STORAGE_KEY, theme);
};

export const applyDocumentTheme = (theme: NavTheme): void => {
  document.documentElement.dataset.theme = theme;
  document.documentElement.style.colorScheme =
    theme === 'realDark' ? 'dark' : 'light';
};
